import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { organisationsQueries } from '../../queries/organisations';

import { useFiltersStore, useQueriesWithGlobal } from '@data-access';

export function useOrganisations() {
  const page = useFiltersStore.use['organisations']().pagination.pageIndex + 1;
  const sorting = useFiltersStore.use['organisations']().sorting;
  const filters = useFiltersStore.use['organisations']().filters;
  const queries = useQueriesWithGlobal(organisationsQueries);

  const query = useQuery({
    ...queries.list({ page, sorting, filters }),
    placeholderData: keepPreviousData,
  });

  return query;
}

export default useOrganisations;
